<div
  [style.font-size.px]="state.fontSize"
  [style.color]="state.fontColor"
  [style.background]="state.backgroundColor"
  [style.padding.px]="10"
  [style.opacity]="opacity"
  [style.display]="'inline-block'"
  #formulaContainer
>
  <ng-container *ngFor="let segment of segments$ | async; index as i">
    <div *ngIf="segment.math">
      <ng-katex [equation]="segment.raw" [options]="{ displayMode: segment.type === 'display' }">
      </ng-katex>
    </div>
    <div *ngIf="!segment.math && (segment?.value | markdownHtml: false)">
      <span [innerHTML]="segment?.value | markdownHtml: false:true | safeHtml"></span>
    </div>
    <div *ngIf="!segment.math && !(segment?.value | markdownHtml: false)"></div>
  </ng-container>
</div>
